export function NewRandomPassword() {
  return Math.random().toString(36).slice(-8) + Math.floor(Math.random() * 10);
}
